import i18next from 'i18next';
import { DateFormatter } from 'infrastructure/functions';
import { DateFormats } from 'infrastructure/enums';
import { DOCUMENTATION_TIME_PLACEHOLDER } from 'infrastructure/consts/tables';
import { convertSecondsToTime } from 'utils/timeHelper';
import { tableSortMap } from 'infrastructure/antd/functions/create-sort-order';

import NoteCommentsColumn from '../clinical-notes-logged/columns/noteComment';

import type { IManualClinicNotes } from 'infrastructure/interfaces';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';
import type { TDeleteCommentFn } from 'infrastructure/hooks/rpm';
import type { SortState } from 'infrastructure/types';

interface IColumnsProps {
  deleteNote: TDeleteCommentFn;
  documentationTimeSort: SortState;
  createdAtSort: SortState;
}

export const columns = ({
  deleteNote,
  documentationTimeSort,
  createdAtSort,
}: IColumnsProps): IBaseTableColumns<IManualClinicNotes> => {
  return [
    {
      label: i18next.t('labels.dateTime'),
      key: 'date',
      width: '16%',
      render(value: string) {
        return (
          <span data-cy="manual-clinic-notes-date">
            {DateFormatter({
              date: value,
              format: DateFormats['MM/dd/yyyy hh:mm:ss a'],
            })}
          </span>
        );
      },
      sortable: true,
      sortKey: 'createdAt',
      sortOrder: tableSortMap[createdAtSort],
    },
    {
      label: i18next.t('labels.documentTime'),
      key: 'documentationTime',
      width: '12%',
      render(documentationTime?: number | null) {
        const actionTime = !documentationTime
          ? DOCUMENTATION_TIME_PLACEHOLDER
          : convertSecondsToTime(documentationTime);
        return (
          <span data-cy="manual-clinic-notes-documentation-time">
            {actionTime}
          </span>
        );
      },
      sortable: true,
      sortKey: 'documentationTime',
      sortOrder: tableSortMap[documentationTimeSort],
    },
    {
      label: i18next.t('labels.electronicallySignedBy'),
      key: 'author',
      width: '22%',
      render(value) {
        return <span data-cy="manual-clinic-notes-author">{value}</span>;
      },
    },
    {
      label: i18next.t('labels.duration'),
      key: 'timeInMinutes',
      width: '12%',
      render(value: any) {
        return <span data-cy="manual-clinic-notes-duration">{value}</span>;
      },
    },
    {
      label: i18next.t('labels.comment'),
      key: 'comment',
      width: '46%',
      responsive: ['md'],
      render(value: any, record) {
        return (
          <NoteCommentsColumn
            value={value}
            record={record}
            deleteNote={deleteNote}
          />
        );
      },
    },
  ];
};
